import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class BankInfoAPI extends DIApi {
  controllerName = 'BankInfos';

  /**
   * Kiểm tra trùng lặp mã ngân hàng và mã khu vực
   * @param {Object} payload - Dữ liệu kiểm tra { bank_code, area_id, exclude_id }
   * @returns {Promise} - Promise chứa kết quả kiểm tra
   */
  checkDuplicateBankCodeAndArea(payload) {
    const request = {
      url: this.getAPIUrl() + '/check-duplicate-bank-code-area',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new BankInfoAPI();
